import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {empty} from '../../../functions';
import {JobService} from '../../../shared/services/job.service';
import {InterestService} from '../../../shared/services/interest.service';
import {Subscription} from 'rxjs';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-modal-company-profile-jobmatches',
    templateUrl: './modal-company-profile-jobmatches.component.html',
    styleUrls: ['./modal-company-profile-jobmatches.component.scss'],
    standalone: false
})
export class ModalCompanyProfileJobmatchesComponent implements OnInit {

  // Icons
  faInfoCircle = faInfoCircle;

  public title = 'Job matches';

  areaofinterestSubscription:Subscription = new Subscription();

  public data: any;

  public jobpostingId = '';

  public view = {
    pageSize: 100,
    pageNumber: 1,
    totalItems: 0,
    data: [],
    isLoading: false
  }

  public areaOfInterests: any[] = [];

  /**
   * Constructor
   *
   * @param activeModal
   */
  constructor(public activeModal: NgbActiveModal,
              private jobService: JobService,
              private interestService: InterestService) {



  }

  /**
   * Ng on init
   */
  ngOnInit(): void {

    if (!empty(this.data)) {

      if (this.data.hasOwnProperty('jobpostingId')) this.jobpostingId = this.data.jobpostingId;

    }


   if (this.jobpostingId) this.loadMatches(this.jobpostingId);

    // Set area of interest data
    if (!empty(this.interestService.areaOfInterests)) {
      this.areaOfInterests = this.interestService.areaOfInterests;

    } else {

      this.areaofinterestSubscription = this.interestService.areaOfInterestsSubject.subscribe( (result:any) => {
        this.areaOfInterests = this.interestService.areaOfInterests;

      });
    }

  }

  /**
   * Ng on destroy
   */
  ngOnDestroy() {

    if (this.areaofinterestSubscription) {
      this.areaofinterestSubscription.unsubscribe();
    }

  }


  /**
   * Load all matches
   */
  loadMatches($jobpostingId: string) {

    this.view.isLoading = true;

    if (empty(this.jobpostingId)) return;

    const $params = {
      pageNumber: this.view.pageNumber,
      pageSize: this.view.pageSize
    };

    this.jobService.apiGetJobPostingMatches($jobpostingId, $params).subscribe( (response:any) => {
      this.view.isLoading = false;
      if (response.hasOwnProperty('data')) {

        this.view.data = Object.assign([], response.data);

        if (response.hasOwnProperty('totalItems')) {
          this.view.totalItems = response.totalItems;
        }

      }

    });

  }

  /**
   * Handle click event of network student component
   *
   * @param string $event
   */
  handleClickEvent($event: string) {

    switch ($event) {

      case 'profile':
        this.activeModal.close(true); // close modal if navigated to profile
        break;

      default:
        break;
    }

  }

}
